import { createAction } from "redux-actions";

export const setConsultaDinamica = createAction(
  'SET_CONSULTAS_DINAMICAS', (consultas) => consultas
);

export const setActiveConsulta = createAction(
  'SET_ACTIVE_CONSULTA', (indice) => indice
);

export const borrarConsultasPrivadas = createAction('BORRAR_CONSULTAS_PRIVADAS');

export const borrarConsultasPublicas = createAction('BORRAR_CONSULTAS_PUBLICAS');

export const setParseoPrivadas = createAction(
  'PARSEO_CONSULTAS_PRIVADAS', (valor) => valor
);

export const setParseoPublicas = createAction(
  'PARSEO_CONSULTAS_PUBLICAS', (valor) => valor
);
